import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  FormControl,
  Stack,
  TextField
} from '@mui/material';

import { useState } from 'react';
import { useTranslation } from 'react-i18next';

import { translations } from 'locales/i18n';

interface Props {
  open: boolean;
  onClose: () => void;
  onCreate: (values: { name: string; description: string }) => void;
}

export const APIKeyCreationDialog = ({ open, onClose, onCreate }: Props) => {
  const { t } = useTranslation();
  const [values, setValues] = useState<{ name: string; description: string }>({
    name: '',
    description: ''
  });

  const resetAfterTimeout = () => {
    setTimeout(() => setValues({ name: '', description: '' }), 500);
  };

  const handleCreate = () => {
    onCreate(values);
    resetAfterTimeout();
  };

  const handleClose = () => {
    onClose();
    resetAfterTimeout();
  };

  return (
    <Dialog open={open}>
      <DialogTitle>{t(translations.pages.chat.apiKeys.createDialog.title())}</DialogTitle>
      <DialogContent>
        <Stack gap={1}>
          <DialogContentText>
            {t(translations.pages.chat.apiKeys.createDialog.description())}
          </DialogContentText>
          <FormControl fullWidth>
            <TextField
              autoFocus
              margin="dense"
              size="small"
              type="text"
              label={t(translations.common.name())}
              fullWidth
              variant="standard"
              value={values.name}
              onChange={e => setValues({ ...values, name: e.target.value })}
            />
          </FormControl>
          <FormControl fullWidth>
            <TextField
              margin="dense"
              size="small"
              type="text"
              label={t(translations.common.description())}
              fullWidth
              variant="standard"
              value={values.description}
              onChange={e => setValues({ ...values, description: e.target.value })}
            />
          </FormControl>
        </Stack>
      </DialogContent>
      <DialogActions>
        <Button onClick={handleClose} variant="outlined" color="error" size="small">
          {t(translations.common.cancel())}
        </Button>
        <Button
          onClick={handleCreate}
          variant="contained"
          size="small"
          sx={{ backgroundColor: 'green' }}
        >
          {t(translations.common.create())}
        </Button>
      </DialogActions>
    </Dialog>
  );
};
